<template>
    <div class="version2-middle-block">
        <TopBlock></TopBlock>
        <BottomBlock></BottomBlock>
    </div>
</template>

<script>
import BottomBlock from './bottomBlock.vue'
import TopBlock from './topBlock.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    BottomBlock,
    TopBlock
  }
}
</script>
